<template>
    <div>
        <footer class=" px-4 py-4 text-left col-sm-12">
            <div class="container">
                <h3 class="m-2">Supported by</h3>
                <img src="../assets/nhs/nhstayside2.png" alt="NHS tayside Logo" height="auto" width="auto" class="m-2 pr-3" @click="goToNHS()" />
                <img src="../assets/nhs/tactran.png" alt="Tactran logo" height="auto" width="auto" class="m-2 pr-3 " @click="goToTactran()"/>
                <img src="../assets/nhs/transport-scotland.png" class="m-2 pr-3" height="auto" width="auto" alt="Transport Scotland Logo" @click="goToTransportScotland()"/>
            </div>
        </footer>
    </div>
</template>
<script>

export default {
    methods: {
        goToNHS() {
            window.open('https://www.nhstayside.scot.nhs.uk/')
        },
        goToTactran() {
            window.open('https://www.tactran.gov.uk/')
        },
        goToTransportScotland() {
            window.open('https://www.transport.gov.scot/')
        },
    },
};
</script>

<style scoped >

img:hover {
   border: 1px solid #4547BF;
   cursor: pointer;
}

</style>
